export default __webpack_public_path__ + "static/media/fa.25b84d6e.xml";